/* MiniModalLoadingContent.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._39xV02Hakr%7Bwidth%3A25pc%7D%0A._0KLXruqi9L%7Bbackground-color%3Avar(--ds-surface-raised%2C%23fff)%7D%0A._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._39xV02pJKa%7Bwidth%3A3pc%7D%0A._0jFU0VpJKa%7Bheight%3A3pc%7D");








import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { LazyAnimatedRovoIcon } from '@atlassian/conversation-assistant-ui-components/ui/LazyAnimatedRovoIcon';
const styles = {
  miniModalMainContainer: "_0bjKvDKxmn _39xV02Hakr _0KLXruqi9L _2OUyjtGk8v _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
  rovoIcon: "_39xV02pJKa _0jFU0VpJKa"
};
export const MiniModalLoadingContent = ({
  topOffset
}: {
  topOffset: number;
}): JSX.Element => <Box testId="conversation-assistant-mini-modal-main-container" xcss={styles.miniModalMainContainer} style={{
  height: `min(320px, calc(100vh - ${topOffset}px))`
}}>
		<Box xcss={styles.rovoIcon}>
			<LazyAnimatedRovoIcon alt="" testId="rovo-loading-animation" />
		</Box>
	</Box>;